module.exports = __webpack_public_path__ + "static/media/vf-button-wallet.52bf743d.svg";